/**
 * @file 认证表单
 * @author
 */
// @ts-nocheck # 忽略全文

import React, {Fragment, useState, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {Form, Row, Col, Input, Button, Checkbox, Modal, message, AutoComplete, Select} from 'antd';
import {cities} from './constants';
import {recordProxy, getQueryString, bCat_2055_request, getIsFlashSale} from '../../util';
import AuthMethodOptModal from './authMethodOptModal';
import AuthTypeOptModal from './authTypeOptModal';
import iconRightSvg from './imgs/icon-right.svg';
import './form.less';
const Message = message;
const {Option} = Select;
interface Props {
    isModalForm?: boolean;
    fetchDelegationAuth: any;
    fetchDelegationSubmit: any;
    fetchAttestSendCode: any;
    anchor: any;
    fetchDelegationType: Function;
    onSubmitSuccess?: Function;
    source?: string;
    fetchEntity: any;
    fetchFlashNum: any;
    flashNum: number;
}

const handleSearchValue = (data, query) => {
    return data.map((item) => {
        const startIndex = item.indexOf(query);
        const startStr = item.slice(0, startIndex);
        const endStr = item.slice(startIndex + query.length);
        return {
            value: item,
            label: (
                <div className="entity-item">
                    {startIndex === -1 ? item : <>
                        {startStr}
                        <span style={{color: '#38f', fontWeight: 'bold'}}>{query}</span>
                        {endStr}
                    </>}
                </div>
            ),
        };
    });
};

export default function AuthFrom(props: Props) {
    // const formRef = React.createRef<FormInstance>();
    const {pathname} = useLocation();
    const formRef = useRef();
    let timer: any = null;
    const count = useRef(60);
    const {
        // fetchDelegationType,
        // fetchDelegationAuth,
        fetchDelegationSubmit,
        fetchEntity,
        fetchFlashNum,
        fetchAttestSendCode,
        anchor,
        isModalForm,
        onSubmitSuccess,
        flashNum,
        source // 表单来源按钮，用于打点
    } = props;
    const channelId = getQueryString('zd') || window.localStorage.getItem('channelId');
    const [options, setOptions] = useState<SelectProps<object>['options']>([]);

    const isFlashSale = getIsFlashSale();

    const debounce = (func, timeout = 100) => {
        let timer: unknown;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {func.apply(this, args);}, timeout);
        };
    };
    const handleSearch = debounce((value: string) => changeValue(value));

    const changeValue = async (value: string) => {
        // const reg = /^[\u4E00-\u9FA5]+$/;  中文
        const reg = /[a-z]/i;
        if (value && !reg.test(value)) {
            getSearchResult(value);
        } else {
            setOptions([]);
        }
    };

    const getSearchResult = (value) => {
        const fetchParam = {
            name: value
        };
        const fetchSearchResult = (params) => fetchEntity({
            ...params,
            ...fetchParam
        }).then(res => {
            const {code, data, message} = res || {};
            if (code === 200) {
                setOptions(handleSearchValue(data, value));
            } else {
                setOptions([]);
            }
        });
        bCat_2055_request(fetchSearchResult);
    };

    const [captchaCount, setCaptchaCount] = useState(60);
    const [captchaBtnStatus, setCaptchaBtnStatus] = useState(true);
    const [captchaTip, setCaptchaTip] = useState('获取验证码');
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [agreeProtocol, setAgreeProtocol] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [authMethodOptShow, setAuthMethodOptShow] = useState(false);
    const [authTypeOptShow, setAuthTypeOptShow] = useState(false);

    const submitRecordProxy = (result: 'success' | 'error', code?: number, msg?: string) => {
        recordProxy(
            anchor
                ? (pathname === '/call_auth' ? 'newCallAuth-submit' : 'newPreAttest-submit')
                : (pathname === '/call_auth' ? 'newCallAuth' : 'newPreAttest'),
            'click',
            JSON.stringify({
                status: result,
                code,
                msg,
                source: source || 'pageForm'
            })
        );
    };
    const authFormTypeFn = () => {
        let pageTypeV = '';
        switch(pathname) {
            case '/call_auth':
                pageTypeV = '2'; // 来电名片
                break;
            default:
                pageTypeV = '1'; // 企业号码
        }
        return pageTypeV;
    };
    const getFlashNum = () => {
        const fetchResult = (params) => fetchFlashNum({
            ...params,
        });
        bCat_2055_request(fetchResult);
    };
    const fetchAuthMethod = (values) => {
        // 為了去重, 英文括號替換為中文括號
        const companyName = values.companyName.replace(/\(/g, '（').replace(/\)/g, '）');
        const params = {
            company_name: companyName,
            user_phone: values.tel,
            code: values.captcha,
            desc: values.desc
            // protocol: agreeProtocol
        };
        setFormData(params);
        setLoading(true);

        const fetchDelegationSubmitFn = (localParams) => fetchDelegationSubmit({
            ...params,
            source: channelId || '',
            'sub_source': authFormTypeFn(),
            ...localParams
        }).then(res => {
            const {code, message} = res || {};
            if (code === 1000) {
                onReset();
                attestMethodCbNext();
                onSubmitSuccess && onSubmitSuccess();
                getFlashNum();
                // 打点
                submitRecordProxy('success', code, message);
            } else if (code === 1002 || code === 1003) {
                openModal('error', {
                    title: '系统提示',
                    okText: '好的',
                    content: code === 1002 ? (
                        <div className="padding-24">
                            未找到您填写的企业，请检查企业名称是否正确或发送邮件至haomakefu@baidu.com进行咨询
                        </div>
                    ) : (
                        <div className="padding-24">同一企业无法重复提交</div>
                    )
                });

                // 打点
                submitRecordProxy('error', code, message);
            } else {
                message && Message.error({
                    content: message,
                    delay: 3000
                });
                // 打点
                submitRecordProxy('error', code, message);
            }

            setLoading(false);
        }).catch(() => {
            setLoading(false);
            submitRecordProxy('error');
        });
        /* eslint-disable */
        bCat_2055_request(fetchDelegationSubmitFn);
        /* eslint-enable */
    };
    const attestMethodCbNext = () => {
        openModal('info', {
            title: '信息提交成功',
            okText: '知道了',
            content: (<div className="page-attest-modal-content">
                <img src={iconRightSvg} className="success-logo"></img>
                <div className="modal-info">
                    <p className="title">您的信息已提交，官方客服将在1个工作日内向您致电。</p>
                    <p className="info-tip">如有其他问题，可发送邮件到haomakefu@baidu.com。</p>
                </div>
            </div>),
        });
    };
    const openModal = (type = 'info', config) => {
        Modal[type]({
            width: 600,
            title: <div className="page-attest-modal-title">{config.title}</div>,
            maskClosable: true,
            centered: true,
            icon: '',
            ...config,
        });
    };
    const submit = (values) => {
        recordProxy('newAttest', 'click', 'submit');
        if (!agreeProtocol) {
            Message.info({
                content: '请您勾选平台协议',
                delay: 2000
            });
            return;
        }
        // 防止重复提交
        if (loading) return false;
        fetchAuthMethod(values);
    };

    const setInputValue = (e) => {
        setPhoneNumber(e.target.value);
    };
    const sendCodeFn = () => {
        if (!captchaBtnStatus) return;
        const fetchAttestSendCodeFn = (localParams) => fetchAttestSendCode({
            type: 2,
            action: 'delegation_auth',
            verity: phoneNumber,
            ...localParams
        }).then(data => {
            const {code, message} = data || {};
            if (code === 200) {
                setTimer();
            } else {
                message && Message.info({
                    content: message,
                    delay: 3000
                });
            }
        }).catch(() => {});

        /* eslint-disable */
        bCat_2055_request(fetchAttestSendCodeFn);
        /* eslint-enable */

        recordProxy(
            pathname.replace('/', '') + '_send_code',
            'click',
            JSON.stringify({phone: phoneNumber})
        );
    };

    // 设置定时器
    const setTimer = () => {
        timer = setInterval(() => {
            count.current = count.current - 1;
            if (count.current <= 0) {
                timer && clearInterval(timer);
                count.current = 60;
            }
            setCaptchaCount(count.current);
            setCaptchaBtnStatus(count.current === 60);
            setCaptchaTip('重新获取');
        }, 1000);
    };
    const onReset = () => {
        formRef.current.resetFields();
    };
    const protocolChange = (e) => {
        setAgreeProtocol(e.target.checked);
    };
    useEffect(() => {
        return () => {
            clearInterval(timer);
        };
    }, [timer]);

    useEffect(() => {
        if (pathname === '/attest') {
            getFlashNum();
        }
    }, [pathname]);

    const companyNameEle = () => {
        return (
            <Form.Item
                name={'companyName'}
                rules={[
                    {
                        required: true,
                        message: '请输入公司名称',
                    },
                    {max: 30, message: '最多支持输入30个字符'},
                ]}
            >
                <AutoComplete
                    dropdownMatchSelectWidth={false}
                    popupClassName="company-complete"
                    options={options}
                    // onSelect={onSelect}
                    onSearch={handleSearch}
                    // open
                >
                    <Input
                        size="large"
                        placeholder="公司名称"
                    />
                </AutoComplete>
            </Form.Item>
        );
    };
    const companyAddressEle = () => {
        return (
            <Form.Item
                name={'desc'}
                rules={[
                    {
                        required: true,
                        message: '请选择需求备注',
                    },
                ]}
            >
                <Select placeholder="需求备注" className="company-address-ele">
                    {isFlashSale
                        ? <Option value="搜索号码认证(限时免费试用中)">
                            搜索号码认证{isFlashSale && <span style={{color: 'red'}}>（限时免费试用中）</span>}
                        </Option>
                        : <Option value="搜索号码认证">
                            搜索号码认证
                        </Option>
                    }
                    <Option value="来电名片认证">来电名片认证</Option>
                    <Option value="号码申诉反馈">号码申诉反馈</Option>
                    <Option value="其他">其他</Option>
                </Select>
            </Form.Item>
        );
    };
    const telEle = () => {
        return (
            <Form.Item
                name={'tel'}
                rules={[
                    {
                        required: true,
                        message: '请输入联系方式',
                    },
                ]}
            >
                <Input className="custom-input"
                    onInput={setInputValue} type="tel" placeholder="联系方式" size="large" />
            </Form.Item>
        );
    };
    const flashNumEle = () => {
        if (isFlashSale && flashNum) {
            return (<div className="flash-num">已有{flashNum}家企业正在免费试用中！</div>);
        }
        return '';
    };
    const captchaEle = () => {
        return (
            <Form.Item
                name={'captcha'}
                rules={[
                    {
                        required: true,
                        message: '请输入验证码',
                    },
                ]}
            >
                <Input
                    className="custom-input get-code-input"
                    placeholder="验证码"
                    size="large"
                    addonAfter={<div className={'get-code ' + (!captchaBtnStatus ? 'disable' : '')}
                        onClick={sendCodeFn}>
                        {!captchaBtnStatus ? captchaCount + 's' : captchaTip}
                    </div>}
                />
            </Form.Item>
        );
    };
    const submitEle = () => {
        return (
            <Button
                className="custom-btn"
                type="primary"
                htmlType="submit"
                loading={loading}
            >
                提交
            </Button>
        );
    };
    const protocolEle = () => {
        return (
            <div className="protocol">
                <Checkbox className="checkbox" onChange={protocolChange}></Checkbox>
                <p>
                    已阅读
                    <a
                        className="link"
                        href="https://haoma.baidu.com/privacy/agreement.html"
                        rel="noopener noreferrer"
                        target="_blank"
                    >《企业号码认证服务协议》</a>和
                    <a
                        className="link"
                        href="https://haoma.baidu.com/privacy/index.html"
                        rel="noopener noreferrer"
                        target="_blank"
                    >《百度号码服务隐私政策》</a>
                </p>
            </div>
        );
    };
    const formItemEle = () => {
        if (isModalForm) {
            return (
                <div>
                    {companyNameEle()}
                    {companyAddressEle()}
                    {telEle()}
                    {captchaEle()}
                    {protocolEle()}
                    {submitEle()}
                    {flashNumEle()}
                </div>
            );
        }
        return (
            <div>
                <Row gutter={24}>
                    <Col span={12}>
                        {companyNameEle()}
                    </Col>
                    <Col span={12}>
                        {companyAddressEle()}
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={12}>
                        {telEle()}
                    </Col>
                    <Col span={12}>
                        {captchaEle()}
                    </Col>
                </Row>
                {submitEle()}
                {flashNumEle()}
                {protocolEle()}
            </div>
        );
    };
    return (
        <Fragment>
            <Form
                name="advanced_search"
                className="ant-advanced-search-form"
                onFinish={submit}
                ref={formRef}
                preserve={false}
                // form={form}
            >
                {formItemEle()}
            </Form>
            <AuthMethodOptModal
                channelId={channelId}
                formData={formData}
                openModal={openModal}
                onReset={onReset}
                authMethodOptShow={authMethodOptShow}
                setAuthMethodOptShow={setAuthMethodOptShow}
                fetchDelegationType={props.fetchDelegationType}/>
            <AuthTypeOptModal
                setAuthTypeOptShow={setAuthTypeOptShow}
                authTypeOptShow={authTypeOptShow}/>
        </Fragment>
    );
}
